module.exports = __webpack_public_path__ + "img/sale2.bcd41477.png";